let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jQZYM")).then(() => parcelRequire('9iZv3'));